export async function registerServiceWorker(): Promise<void> {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  try {
    await navigator.serviceWorker.register("/worker.js");
  } catch (error) {
    console.error("Service worker registration failed", error);
  }
}

export async function cacheModelAssets(urls: string[]): Promise<void> {
  if (!navigator.serviceWorker?.controller) {
    return;
  }

  navigator.serviceWorker.controller.postMessage({
    type: "CACHE_MODEL",
    urls
  });
}
